// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ItemResponse,
    ItemResponseFromJSON,
    ItemResponseToJSON,
    LearningObjective,
    LearningObjectiveFromJSON,
    LearningObjectiveToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChildItem
 */
export interface ChildItem {
    /**
     * 
     * @type {ItemResponse}
     * @memberof ChildItem
     */
    item: ItemResponse;
    /**
     * 
     * @type {string}
     * @memberof ChildItem
     */
    notes?: string;
    /**
     * 
     * @type {Array<LearningObjective>}
     * @memberof ChildItem
     */
    learningObjectives?: Array<LearningObjective>;
    /**
     * 
     * @type {number}
     * @memberof ChildItem
     */
    videoStartTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ChildItem
     */
    videoStopTime?: number;
}

export function ChildItemFromJSON(json: any): ChildItem {
    return {
        'item': ItemResponseFromJSON(json['item']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'learningObjectives': !exists(json, 'learning_objectives') ? undefined : (json['learning_objectives'] as Array<any>).map(LearningObjectiveFromJSON),
        'videoStartTime': !exists(json, 'video_start_time') ? undefined : json['video_start_time'],
        'videoStopTime': !exists(json, 'video_stop_time') ? undefined : json['video_stop_time'],
    };
}

export function ChildItemToJSON(value?: ChildItem): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'item': ItemResponseToJSON(value.item),
        'notes': value.notes,
        'learning_objectives': value.learningObjectives === undefined ? undefined : (value.learningObjectives as Array<any>).map(LearningObjectiveToJSON),
        'video_start_time': value.videoStartTime,
        'video_stop_time': value.videoStopTime,
    };
}


